import { render, staticRenderFns } from "./BlockEditAgent.vue?vue&type=template&id=839be4e4&scoped=true&"
import script from "./BlockEditAgent.vue?vue&type=script&lang=js&"
export * from "./BlockEditAgent.vue?vue&type=script&lang=js&"
import style0 from "./BlockEditAgent.vue?vue&type=style&index=0&id=839be4e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839be4e4",
  null
  
)

export default component.exports